export default "__VITE_ASSET__O$6hoetc__"